"use strict";
/**
 * This code was AUTOGENERATED using the kinobi library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun kinobi to update it.
 *
 * @see https://github.com/metaplex-foundation/kinobi
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.addMemo = exports.getAddMemoInstructionDataSerializer = void 0;
const umi_1 = require("@metaplex-foundation/umi");
const serializers_1 = require("@metaplex-foundation/umi/serializers");
const shared_1 = require("../shared");
function getAddMemoInstructionDataSerializer() {
    return (0, serializers_1.struct)([['memo', (0, serializers_1.string)()]], {
        description: 'AddMemoInstructionData',
    });
}
exports.getAddMemoInstructionDataSerializer = getAddMemoInstructionDataSerializer;
// Instruction.
function addMemo(context, input) {
    // Program ID.
    const programId = context.programs.getPublicKey('splMemo', 'Memo1UhkJRfHyvLMcVucJwxXeuD728EqVDDwQDxFMNo');
    // Accounts.
    const resolvedAccounts = {};
    // Arguments.
    const resolvedArgs = { ...input };
    // Accounts in order.
    const orderedAccounts = Object.values(resolvedAccounts).sort((a, b) => a.index - b.index);
    // Keys and Signers.
    const [keys, signers] = (0, shared_1.getAccountMetasAndSigners)(orderedAccounts, 'programId', programId);
    // Data.
    const data = getAddMemoInstructionDataSerializer().serialize(resolvedArgs);
    // Bytes Created On Chain.
    const bytesCreatedOnChain = 0;
    return (0, umi_1.transactionBuilder)([
        { instruction: { keys, programId, data }, signers, bytesCreatedOnChain },
    ]);
}
exports.addMemo = addMemo;
//# sourceMappingURL=addMemo.js.map